import { applyMiddleware, combineReducers, createStore, compose, Action } from "redux";
import { thunk } from "redux-thunk";
import authReducer from "./reducers/auth";
import postReducer from "./reducers/post";
import siteSettingsReducer from "./reducers/siteSettings";
import categoryReducer from "./reducers/category";
import productReducer from "./reducers/product";
import newsletterReducer from "./reducers/newsletter";
import contactFormReducer from "./reducers/contactForm";

// Root state tipini tanımlayalım
export interface RootState {
  auth: any;
  posts: any;
  siteSettings: any;
  categories: any;
  products: any;
  newsletter: any;
  contactForm: any;
}

const initialState = {};

const reducers = combineReducers({
  auth: authReducer,
  posts: postReducer,
  siteSettings: siteSettingsReducer,
  categories: categoryReducer,
  products: productReducer,
  newsletter: newsletterReducer,
  contactForm: contactFormReducer
});

// Logger middleware'i için tip tanımlaması
const loggerMiddleware = (store: any) => (next: any) => (action: Action) => {
  console.log('Dispatching:', action);
  const result = next(action);
  console.log('Next State:', store.getState());
  return result;
};

// Güvenli devtools entegrasyonu
const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Store oluşturma
const store = createStore(
  reducers,
  initialState,
  composeEnhancers(applyMiddleware(thunk as any, loggerMiddleware as any))
);

export default store;
